import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { getAliasString } from '@/utils/common';
import { useTypedSelector } from '@/store/store';
import { selectProductResource } from '@/store/reducers/pages/product/product';

import Relations from './components/Relations';
import Blog from './components/Blog';

function Footer() {
  const router = useRouter();
  const alias = getAliasString(router.query.alias);

  const { data } = useTypedSelector((state) => {
    return selectProductResource(state, alias);
  });

  return (
    <Component>
      <Relations id={data?.id} />
      <Blog id={data?.id} />
    </Component>
  );
}

export default Footer;

const Component = styled.div`
  margin-top: 18px;
`;
